import { useState } from 'react'
import type { CSSProperties } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import { filterPeanutProductOptions } from '@/constants/peanutProducts'

interface ProductSelectInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

const inputStyle: CSSProperties = {
  fontFamily: 'Lexend Deca',
  fontSize: '12px',
  height: '40px',
  border: '1px solid #E9E9EA',
  borderRadius: '8px',
}

const ProductSelectInput = ({
  value,
  onChange,
  placeholder = 'Select product',
}: ProductSelectInputProps) => {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState<string | null>(null)
  const suggestions = filterPeanutProductOptions(query ?? '')

  const close = () => {
    setOpen(false)
    setQuery(null)
  }

  const handleSelect = (option: string) => {
    onChange(option)
    close()
  }

  return (
    <div className="relative w-full">
      <div className="relative">
        <input
          type="text"
          value={query ?? value}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(close, 200)}
          placeholder={placeholder}
          className="w-full px-4 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          style={inputStyle}
          aria-label="Product"
          aria-expanded={open}
          aria-haspopup="listbox"
        />
        <FiChevronDown
          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
          style={{ width: 16, height: 16, color: '#212126', opacity: 0.8 }}
        />
      </div>
      {open && (
        <div
          role="listbox"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            border: '1px solid #E9E9EA',
            borderTop: 'none',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            maxHeight: '240px',
            overflowY: 'auto',
          }}
        >
          {suggestions.length === 0 && (
            <div
              style={{
                padding: '10px 16px',
                fontFamily: 'Lexend Deca',
                fontSize: '13px',
                color: '#6B7280',
              }}
            >
              No matching product. Products are added to the shared list.
            </div>
          )}
          {suggestions.map((option, index) => (
            <div
              key={option}
              role="option"
              aria-selected={value === option}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(option)}
              style={{
                padding: '10px 16px',
                cursor: 'pointer',
                fontFamily: 'Lexend Deca',
                fontSize: '13px',
                color: '#212126',
                borderBottom:
                  index < suggestions.length - 1 ? '1px solid #F3F4F6' : 'none',
              }}
              className="hover:bg-gray-50"
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProductSelectInput
